export function formatCurrency(value?: number) {
  if (!value && value !== 0) return "-";
  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}
